export default __webpack_public_path__ + "static/media/menu6_hl.79923ef2.png";